import Fields from './Fields';
import Products from './Products';

const ProductScope = () => {
  return (
    <div
      style={{
        maxHeight: '50vh',
        overflowY: 'auto',
        backgroundColor: '#fff',
      }}
    >
      <Fields />
      <Products />
    </div>
  );
};

export default ProductScope;
